export default __webpack_public_path__ + "static/media/HelveticaNowText-Medium.0450be8c.otf";